/* eslint-disable no-debugger */
import React from 'react'
import {
  FETCH_CREDIT_REQUEST,
  FETCH_CREDIT_SUCCESS,
  FETCH_CREDIT_ERROR,
  FETCH_CREDIT_RESULT_SUCCESS,
  FETCH_CREDIT_RESULT_ERROR,
  LOADING_SIMULATION_RESULT,
  GET_SIMULATION_CREDIT,
  NEXT_STEP_SIMULATION,
  PREV_STEP_SIMULATION,
  PUT_DECLARACION_JURADA,
  USER_PENDIENTE_PC
} from '../constants/credit'
import {
  LOADING_SEND_SOLICITUD_CREDITO,
  GET_SEND_SOLICITUD_CREDITO_SUCCESS,
  GET_SEND_SOLICITUD_CREDITO_ERROR
} from '../constants/solicitudCredito'
import { activeStep, deactivateStep } from '../actions/utils'
import {
  reqGetCreditResult,
  reqGetCreditOffer,
  reqCompletedProccess,
  reqCompletedProcessDeclaracion
} from '../../utils/httpRequests/credit'
import history from '../../utils/history'
import {
  gtagOKEvent,
  gtagErrorEvent,
  gtagPurchaseEvent
} from '../../utils/gtag'
import {
  warningModal,
  isPensionado
} from '../../utils/misc'
import * as logger from '../../utils/logger'
import steps from '../../containers/SimulationSteps/steps'
// Llamada a la oferta de credito
export function requestCreditOffer (token) {
  return (dispatch) => {
    dispatch({
      type: FETCH_CREDIT_REQUEST
    })
    reqGetCreditOffer(token)
      .then(({ data }) => {
        if (data.hasOferta) {
          dispatch(getCreditOfferSuccess(data))
        } else {
          const notHasOferta = (
            <span className='eligible-modal'>
              {data.message}, para aclarar dudas, puedes hacerlo en línea a través de Whatsapp.&nbsp;
              <a
                href="https://api.whatsapp.com/send?phone=56936573560&text=%C2%A1Hola%20Caja%20Los%20Andes!#"
                onClick={() => {
                  gtagOKEvent('Contacto Soporte Whatsapp', 'Filtro Paso 1')
                }}
                target='_blank'
                rel='noopener noreferrer'>Ingresa aquí</a>
            </span>
          )
          dispatch(getCreditOfferError(notHasOferta))
        }
      })
      .catch((error) => {
        error = 'Error al consultar su crédito'
        dispatch(getCreditOfferError(error))
        // console.log(error)
      })
  }
}

export function getCreditOfferSuccess (credit) {
  return {
    type: FETCH_CREDIT_SUCCESS,
    payload: credit
  }
}

export function getCreditOfferError (err) {
  return {
    type: FETCH_CREDIT_ERROR,
    payload: err
  }
}

// Llamada a la simulacion
export function requestCreditSimulation (simulation, token) {
  return (dispatch) => {
    dispatch(loadingResultSimulation())
    reqGetCreditResult(simulation, token)
      .then(response => {
        dispatch(getCreditResultSuccess(response.data))
        dispatch(getSimulationCredit(simulation))
        dispatch(activeStep())
        gtagOKEvent('Simula tu credito', 'Paso OK')
        // console.log(response)
        logger.info('DEBUG requestCreditSimulation')
      })
      .catch((error) => {
        // console.log(error)
        // logger.error(error)
        error = 'En estos momentos no podemos atender tu solicitud, por favor intenta más tarde'
        dispatch(getCreditResultError(error))
        dispatch(deactivateStep())
        gtagErrorEvent('Simula tu credito', 'Paso error', error)
      })
  }
}

export function getCreditResultSuccess (creditResult) {
  return {
    type: FETCH_CREDIT_RESULT_SUCCESS,
    payload: creditResult
  }
}

export function getCreditResultError (err) {
  return {
    type: FETCH_CREDIT_RESULT_ERROR,
    payload: err
  }
}

export function getSimulationCredit (simulation) {
  return {
    type: GET_SIMULATION_CREDIT,
    payload: simulation
  }
}

// Capa de carga en la simulacion
export function loadingResultSimulation () {
  return {
    type: LOADING_SIMULATION_RESULT
  }
}

export function completedProccess (simulationId, idDeclaracion = null, token) {
  return (dispatch, getState) => {    
    console.log('Antes del actualizar: ', idDeclaracion);
    dispatch({type: LOADING_SEND_SOLICITUD_CREDITO})
    if(idDeclaracion !== null) {
      reqCompletedProcessDeclaracion(idDeclaracion, token)
        .then(response => {
          //console.log('Response de reqCompletedProcessDeclaracion: ', response);
          dispatch({
            type: PUT_DECLARACION_JURADA
          })
        })
        .catch((error) => {
          console.log('Error al actualizar Declaracion: ', error);
        })
    }
    console.log('Despues de actualizar');
    reqCompletedProccess(simulationId, token)
      .then(response => {
        // console.log(response)
        console.log('Entro al reqCompletedProccess');
        dispatch({
          type: GET_SEND_SOLICITUD_CREDITO_SUCCESS,
          payload: response.data.result.solicitudCredito
        })
        const {
          userSimulation
        } = getState().credit
        gtagPurchaseEvent(simulationId, userSimulation.amount, userSimulation.cuotas)
        history.push('/proceso-completado')
        logger.info('DEBUG completedProcess')
      })
      .catch((error) => {
        logger.error(error)
        dispatch({type: GET_SEND_SOLICITUD_CREDITO_ERROR})
        warningModal()
        // console.log('error el enviar la solicitud')
      })
      console.log('Termino reqCompletedProccess');
  }
}

// Steps del credito
export function nextStepSimulation () {
  // console.log("VASS::NextStepSimulacion Start")
  return (dispatch, getState) => {
    const { credit, user, document } = getState()
    // console.log("VASS::creditState: ", credit)
    // console.log("VASS::user: ", user)
    // console.log("vASS::document: ", document)
    const completedSteps = [
      credit.creditSimulation.completed,
      user.updatedUser,
      ((document.completedDateFileUpload && document.completedFileUpload) || isPensionado(credit.creditOffer.tipoAfiliado))
    ]
    if (completedSteps[credit.currentStep]) {
      dispatch({type: NEXT_STEP_SIMULATION})
      history.push(steps[credit.currentStep + 1].path)
    }
  }
}

export function prevStepSimulation () {
  return (dispatch, getState) => {
    const { credit } = getState()
    dispatch({ type: PREV_STEP_SIMULATION })
    history.push(steps[credit.currentStep - 1].path)
  }
}

export function userPendientePC(check) {
  console.log("dispatch userPend", check)
  return (dispatch) => {
    dispatch({
      type: USER_PENDIENTE_PC,
      payload: check
    })
  }
}